/**
 * Les passages du support — côté patron.
 *
 * Le plan d'identité staff promet une chose au client : **l'éditeur n'entre
 * jamais chez lui en silence.** Chaque session de support porte un nom, une
 * heure et un motif ; ce module est ce qui les lui rend.
 *
 * Réservé au patron, comme en base (`my_support_sessions`) : c'est lui qui a
 * signé le contrat, c'est à lui que la trace est due. Un verbe N1 comme un
 * autre — l'agent pourra répondre à « le support est-il passé chez moi ? ».
 */
import { z } from "zod";
import { ActionLevel } from "../../levels.js";
import { defineService } from "../../service.js";
import type { ExecutionContext } from "../../context.js";
import type { SupportVisit } from "../staff/console.js";

export const listSupportVisitsInput = z.object({
  confirmationId: z.string().optional(),
});

export type ListSupportVisitsInput = z.infer<typeof listSupportVisitsInput>;

export interface SupportVisitRepository {
  list(ctx: ExecutionContext): Promise<SupportVisit[]>;
}

export function createSupportServices(repo: SupportVisitRepository) {
  const listerPassagesSupport = defineService<ListSupportVisitsInput, SupportVisit[]>({
    name: "lister_passages_support",
    level: ActionLevel.Read,
    allowedRoles: ["patron"],
    handler: (ctx) => repo.list(ctx),
  });

  return { listerPassagesSupport };
}

export type SupportServices = ReturnType<typeof createSupportServices>;
